module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"today":"Сегодня в"}}')
  delete Component.options._Ctor
}
